module.exports = __webpack_public_path__ + "static/media/plan_process_tree.3686ffbb.svg";